import React from "react";
import OwlCarousel from "react-owl-carousel";

const HomeCarouselLogo = () => {
  return (
    <OwlCarousel className="a1now-home-logo-carousel owl-carousel owl-theme owl-drag" autoWidth nav dots={false}>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/bnt1-hover.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2021/07/btv-hd-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2021/07/nova-hd-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/NOVA_News_365x170.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/diema-hover.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/bloomberg_tv_bg.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/bnt-2.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/bnt-world.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/Evrokom-HD_NEW_06-01-2019.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/bulgaria-24-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/logo-mediaset-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2021/11/bTV_comedy_HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2021/11/bTV_cinema_HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/kino-nova.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/star-channel-HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/star-life-logo-HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/10/tv1000-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/star-crime-logo-HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/diema-family.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2020/11/FilmBoxStars-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/axn.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/axn-24-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/axn-white-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/amc.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/BTV_Story_HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/24_kitchen_HD_632x146.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/tlc.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/ohota-ribalka.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/Wness-TV-HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/foodnetwork-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/wild-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2020/11/TravelChannel-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/travel-tv-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/10/mtv-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/bTV_action_HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/10/max-sport-1.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/10/max-sport-2.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/10/maxsport3-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2019/01/maxsport4-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/nova-sport-hd.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/RING_HD.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/eurosport_1_hd_424x170.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/hd-bnt.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/automotor.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/viasat_HISTORY_HD_164x236.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/Viasat_Nature_hd_164x362.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/Viasat_Explore_HD_164x236.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/10/Epic-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/fightbox.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/NG-HD-black.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/discovery_hd_2019.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/da-vinci.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2022/03/HistoryHD_Logo_2015_4C_Black_type.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/cn-hover.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/nickelodeon.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/ducktv-hover.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/ekids.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/nick-jn-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/karusel-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/cartoonito.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2020/11/SuperToons-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/on-air-hover.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2024/02/EuronewsBulgaria.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/bit.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/cnn-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/dw-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/russia24-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/france-24-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2020/11/reality-kings-94x71.png" alt="" />
      </div>
      <div className="a1now-home-logo-slide">
        <img src="https://media.a1.bg/xploretv/uploads/2018/09/drocel-tv-94x71.png" alt="" />
      </div>
    </OwlCarousel>
  );
};

export default HomeCarouselLogo;
